import { render, staticRenderFns } from "./TabsDetailsFicheContrat.vue?vue&type=template&id=dcb3aa9a&"
import script from "./TabsDetailsFicheContrat.vue?vue&type=script&lang=js&"
export * from "./TabsDetailsFicheContrat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports